import { Editor, type JSONContent } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import { Markdown } from 'tiptap-markdown';

// Converts a markdown string into Tiptap JSON content suitable for the
// `content` field on a CollaborativeDocument. Used when callers want to
// drive the document from a plain markdown source instead of the realtime
// collab editor.
export const markdownToContentJson = (markdown: string): JSONContent => {
  const editor = new Editor({
    // Mirror SimpleMarkdownEditor's extension set so values round-trip without
    // losing structure. Heading/codeBlock/blockquote/horizontalRule stay
    // disabled (the editor doesn't render them); link stays enabled so
    // markdown link syntax converts to a Link mark.
    extensions: [
      StarterKit.configure({
        heading: false,
        codeBlock: false,
        blockquote: false,
        horizontalRule: false,
      }),
      Markdown.configure({ html: false }),
    ],
    content: markdown,
  });
  try {
    return editor.getJSON();
  } finally {
    editor.destroy();
  }
};
